const InflateComponents = require('utils/framework/InflateComponents');
const wrapWithReduxProvider = require('utils/framework/wrapWithReduxProvider');


Sephora.Util.InflatorSPA = {};

const inflateSpa = () => {
    let components;
    const componentsElement = document.body.querySelector('#linkSPA');

    if (componentsElement) {
        components = JSON.parse(componentsElement.innerHTML);
    }

    if (!components) {
        return Promise.reject(new Error('No JSON data in #linkSPA tag.'));
    }

    // require.ensure is used to package nested requires in components.chunk.js
    // rather than priority.bundle.js in order to keep priority.bundle.js lean
    return require.ensure([], function (require) {
        const SpaUtils = require('../Spa');
        let RootComponent;

        if (SpaUtils.isSpaTemplate(Sephora.renderedData.template)) {
            RootComponent = require('../../SpaApplication');
        } else {
            RootComponent = wrapWithReduxProvider(require('pages/' + Sephora.renderedData.template));
        }

        if (components['Header']) {
            const Header = require('components/Header/Header');
            InflateComponents.render(Header, components['Header'].props, document.body.querySelector('[rootid="Header"]'), true);
        }

        const componentName = RootComponent.prototype?.class || RootComponent.class;
        const componentElement = document.body.querySelector(`[rootid="${componentName}"]`);
        const { props = {} } = components[componentName] || {};

        if (RootComponent.prototype?.renderOnLoadEvent) {
            InflateComponents.queue(RootComponent, props, RootComponent.prototype.renderOnLoadEvent, componentElement);
        } else {
            InflateComponents.render(RootComponent, props, componentElement);
        }

        const GlobalContent = require('components/GlobalContent/GlobalContent');
        InflateComponents.render(GlobalContent, components[GlobalContent.prototype.class].props, document.body.querySelector('[rootid="' + GlobalContent.prototype.class + '"]'), true);
        // InflateComponents.render(Router, components[Router.prototype.class].props, document.body.querySelector('[rootid="'+Router.prototype.class+'"]'), true);

        Sephora.Util.InflatorComps.services.loadEvents.HydrationFinished = true;
        const { HydrationFinished } = require('./Events');
        window.dispatchEvent(new CustomEvent(HydrationFinished));
    }, 'components');
};

module.exports = { inflateSpa };
